import { NavigationAside } from './navigation.aside';

export const EmptyNavigationAside = () => <NavigationAside hasNavigationApplication={false} />;
